module.exports = __webpack_public_path__ + "img/Primordial-Process-1.f05cd0f0.png";